import { render, staticRenderFns } from "./EditQuiz.vue?vue&type=template&id=51f0ba1f&scoped=true&"
import script from "./EditQuiz.vue?vue&type=script&lang=js&"
export * from "./EditQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EditQuiz.vue?vue&type=style&index=0&id=51f0ba1f&prod&scoped=true&lang=css&"
import style1 from "./EditQuiz.vue?vue&type=style&index=1&id=51f0ba1f&prod&scoped=true&lang=css&"
import style2 from "./EditQuiz.vue?vue&type=style&index=2&id=51f0ba1f&prod&scoped=true&lang=css&"
import style3 from "./EditQuiz.vue?vue&type=style&index=3&id=51f0ba1f&prod&scoped=true&lang=css&"
import style4 from "./EditQuiz.vue?vue&type=style&index=4&id=51f0ba1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0ba1f",
  null
  
)

export default component.exports